import Marquee from "react-fast-marquee";
import { LASERCUT } from "@/constants/testIds";

export const EditorialMarquee = () => (
  <div
    data-testid={LASERCUT.marqueeText}
    className="border-y border-linecol bg-iron py-6 md:py-8"
  >
    <Marquee speed={28} gradient={false}>
      {Array.from({ length: 4 }).map((_, i) => (
        <span key={i} className="flex items-center">
          <span className="font-heading text-3xl md:text-5xl px-8 text-transparent [-webkit-text-stroke:1px_#D4AF37]">
            CUSTOM METAL ART
          </span>
          <span className="font-heading text-3xl md:text-5xl px-8 text-chromed/90">
            PRESISI CNC
          </span>
          <span className="font-heading text-3xl md:text-5xl px-8 text-transparent [-webkit-text-stroke:1px_#E0E0E0]">
            FINISHING TAHAN CUACA
          </span>
        </span>
      ))}
    </Marquee>
  </div>
);
